import React, {useState, useEffect} from 'react';
import {
  Stack,
  Checkbox,
  Form,
  FormControl,
  Button,
  Paragraph,
  Textarea,
  TextLink, Flex, Badge,
} from '@contentful/f36-components';
import {useAutoResizer, useSDK} from '@contentful/react-apps-toolkit';
import {OrderDetail} from "../components/orders-list/OrderDetail";

const MAXLENGTH = 25000

const Dialog = () => {
  useAutoResizer();
  const sdk = useSDK();
  const [type, setType] = useState('locales')
  const [locales, setLocales] = useState([])
  const [targetLocales, setTargetLocales] = useState([])
  const [busyLanguages, setBusyLanguages] = useState([])
  const [instructions, setInstructions] = useState('')
  const [context, setContext] = useState('')

  const [sourceLocale, setSourceLocale] = useState(sdk.locales.default);

  useEffect(() => {
    let { type, locales, busyLanguages, instructions, sourceLocale: srcLocale } = sdk.parameters.invocation
    setType(type)
    setLocales(locales)
    //setTargetLocales(targetLocales)
    setBusyLanguages(busyLanguages)
    setInstructions(instructions)
    if (srcLocale) setSourceLocale(srcLocale)
  }, [sdk])

  const languageOptions = () => {

    const langDefault = locales.find(l => l.code === sourceLocale)

    return [
      langDefault ? (
        <Checkbox
          key={langDefault.code}
          id={langDefault.code}
          value={langDefault.code}
          isDisabled={true}
          >{langDefault.name} ({langDefault.code})</Checkbox>
      ) : null,
      ...locales
        .filter(l => l.code !== sourceLocale)
        .sort((a, b) => a.name - b.name)
        .map(locale => (
            <Flex key={locale.code} justifyContent="space-between">
              <Checkbox
                key={locale.code}
                id={locale.code}
                value={locale.code}
                isDisabled={busyLanguages.includes(locale.code)}
                isChecked={targetLocales.map(l => l.code).includes(locale.code)}
                onChange={(e) => {
                  if(targetLocales.map(l => l.code).includes(locale.code)) {
                    setTargetLocales(targetLocales.filter(l => l.code !== locale.code))
                  } else {
                    const newTargetLocales = targetLocales.slice()
                    newTargetLocales.push(locale)
                    setTargetLocales(newTargetLocales)
                  }
                }}
              >{locale.name} ({locale.code})</Checkbox>
              {busyLanguages.includes(locale.code) && <Badge variant="warning">IN PROGRESS</Badge>}
            </Flex>
        ))
    ].filter(v => !!v)

  }

  const selectOrDeselectAll = () => {
    if(targetLocales.length === locales.length -1) {
      return (
        <TextLink
          href="#"
          onClick={() => setTargetLocales([])}
        >
          Deselect all
        </TextLink>
      )
    } else {
      return (
        <TextLink
          href="#"
          onClick={() => setTargetLocales(locales.filter(l => l.code !== sourceLocale))}
        >
          Select all
        </TextLink>
      )
    }
  }

  switch (type) {
    case 'locales':
      return (
        <Form style={{ padding: '20px' }}>
          <FormControl.Label as="legend" >
            <div style={{ float: 'left' }}>Select locale(s)</div>
            <div style={{ float: 'right' }}>
              {selectOrDeselectAll()}
            </div>
            <div style={{ clear: 'both' }}></div>
          </FormControl.Label>
            {languageOptions()}
          <Stack justifyContent="end">
            <Button
              variant="positive"
              onClick={() => sdk.close({targetLocales})}
            >Save</Button>
            <Button
              variant="transparent"
              onClick={() => sdk.close()}
            >Cancel</Button>
          </Stack>
        </Form>
      )
    case 'instructions':
      return (
        <Form style={{ padding: '20px' }}>
          <Paragraph>Notes for the translator</Paragraph>
          <Textarea
            style={{ minHeight: '200px' }}
            value={instructions}
            onChange={(e) => {
              if((instructions + e.target.value).length <= MAXLENGTH)
                setInstructions(e.target.value);
            }}>
          </Textarea>
          <div style={{ textAlign: 'right', marginBottom: '10px' }}>{instructions.length}/{MAXLENGTH}</div>
          <Stack justifyContent="end">
            <Button
              variant="positive"
              onClick={() => sdk.close({instructions})}
            >Save</Button>
            <Button
              variant="transparent"
              onClick={() => sdk.close()}
            >Cancel</Button>
          </Stack>
        </Form>
      )
    case 'context':
      return (
          <Form style={{ padding: '20px' }}>
            <Paragraph>Context for Machine Translation</Paragraph>
            <Textarea
                style={{ minHeight: '200px' }}
                value={context}
                onChange={(e) => {
                  if((context + e.target.value).length <= MAXLENGTH)
                    setContext(e.target.value);
                }}>
            </Textarea>
            <div style={{ textAlign: 'right', marginBottom: '10px' }}>{context.length}/{MAXLENGTH}</div>
            <Stack justifyContent="end">
              <Button
                  variant="positive"
                  onClick={() => sdk.close({context})}
              >Save</Button>
              <Button
                  variant="transparent"
                  onClick={() => sdk.close()}
              >Cancel</Button>
            </Stack>
          </Form>
      )
    case 'order-details':
      return <OrderDetail order={sdk.parameters.invocation.order} />
    default:
      return <></>
  }
};

export default Dialog;
